<template>
  <!-- 弹窗头部 -->
  <div class="box">
    <header>
      <div class="title">
        <img class="title-img-left" src="../assets/imgs/memory/title_left.png" alt="">
        <span class="title-text" v-if="title">{{title}}</span>
        <span class="title-text" v-else v-html="titleHtml"></span>
        <img class="title-img-right" src="../assets/imgs/memory/title_right.png" alt="">
      </div>
      <div class="split-line"></div>
    </header>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    titleHtml: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  // height: 38px;
  header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title {
      margin-bottom: 10px;
      .title-img-left {
        margin-right: 11px;
      }
      .title-text {
        font-size: 18px;
        font-weight: bold;
        color: #566087;
        /deep/ em {
          color: #0078fc;
        }
      }
      .title-img-right {
        margin-left: 11px;
      }
    }
    .split-line {
      width: 100%;
      height: 2px;
      background: #566087;
      opacity: 0.1;
    }
  }
}
</style>